import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import moment from 'moment';
import classNames from 'classnames';
import { environmentURLs } from '../common/CaptureEnvironment';
import { RefundReport } from './RefundReport';


import './PurchaseReport.scss';

import {
  TableHeader,
  TablePagination,
  TableContent,
  TableContainer,
  TableColumnDndContainer,
  TABLE_LAYOUT_OPTIONS,
  TextRenderer,
  CELL_CLASSES,
  CELL_RENDERERS,
  COLUMN_TYPES,
  classNamePrefix,
  preventDefaultBehavior,
  usePreventTableScrollingRef,
  focusLastCell,
  DEFAULT_ROWS_PER_PAGE_OPTIONS,
  DateRangePicker,
  IconFileDownload,
  Loader,
  Tabs,
  Tab,
  TabPanel
} from 'cdk-radial';

import Page from '../page/index';
import AuthComponent from '../common/AuthComponent';
import { getDealerPurchaseReport } from '../../redux/connectedComponent/dealerPurchaseHistory/dealerPurchaseHistory.slice';
import { getDealerRefundHistory } from '../../redux/connectedComponent/dealerRefundHistory/dealerRefundHistory.slice';
import { getSolutionSubscriptionInfo, getAuthorisationStatus } from '../../redux/connectedComponent/subscriptionManagement/subscriptionManagement.slice';

const COLOR_STROKE = '#006CFA';
const LOADER_STYLE = {
  stroke: COLOR_STROKE,
  "margin-top": '200px ',
  display: 'flex'
};

function PurchaseReport() {
  const dispatch = useDispatch();

  const state = useSelector(state => state);

  let solutionSubscriptionInfo = state && state.subscriptionManagementSlice && state.subscriptionManagementSlice.solutionSubscriptionInfo ? state.subscriptionManagementSlice.solutionSubscriptionInfo : {};

  let dealerPurchaseHistoryData, dealerPurchaseHistoryDataLoaded,
    errorInGettingDealerPurchaseHistroyData, userEmail, token;

  if (state && state.dealerPurchaseHistorySlice) {
    ({
      dealerPurchaseHistoryData, dealerPurchaseHistoryDataLoaded,
      errorInGettingDealerPurchaseHistroyData
    } = state && state.dealerPurchaseHistorySlice);
  }

  if (state && state.loginDetailsSlice) {
    ({ userEmail } = state.loginDetailsSlice)
  }
  if (state && state.loginDetailsSlice && state.loginDetailsSlice.authenticationToken) {
    token = state.loginDetailsSlice.authenticationToken;
  }
  const { authorised, canPurchaseEnabled } = state.loginDetailsSlice && state.loginDetailsSlice;
  const todaysDate = moment();
  const threeMonthsOldDateFromTodaysDate = moment().subtract(3, 'months');

  const [endDate, setEndDate] = useState(todaysDate);
  const [startDate, setStartDate] = useState(threeMonthsOldDateFromTodaysDate);

  const handleDateChange = ({
    startDate: momentStartDateObject,
    endDate: momentEndDateObject
  }) => {
    setStartDate(momentStartDateObject);
    setEndDate(momentEndDateObject);
  };

  const componentMainClass = `${classNamePrefix}-table`;
  const agGridThemeClass = 'ag-theme-balham';
  const purchaseTableClass = 'purchaseTable';
  const tableClass = classNames(componentMainClass, agGridThemeClass, purchaseTableClass);

  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const [gridApi, setGridApi] = useState(null);
  const [currentPage, setCurrentPage] = useState();
  const [totalPages, setTotalPages] = useState();
  const [totalRows, setTotalRows] = useState();
  const [showPagination, setShowPagination] = useState(true);
  const [searchInputValue, setSearchInputValue] = useState('');
  const [gridDataPrepared, setGridDataPrepared] = useState(false);
  const [gridDataManipulationComplete, setGridDataManipulationComplete] = useState(false);
  const isAgGridReady = !!gridApi;
  const hasNoRows = totalRows === 0;
  const defaultPaginationPageSize = DEFAULT_ROWS_PER_PAGE_OPTIONS[0];
  const rowsPerPageOptions = DEFAULT_ROWS_PER_PAGE_OPTIONS;


  const isOutsideRange = ((day) => {
    return (moment().diff(day) < 0);
  })

  //--
  let { dealerRefundHistoryData, dealerRefundHistoryDataLoaded, errorInGettingDealerRefundeHistroyData } = state && state.dealerRefundHistorySlice || {};
  let entityIdLocationMap = {};

  const {
    allLocations = []
  } = state.loginDetailsSlice;
  const entityIds = allLocations.reduce((p, n = {}) => {
    entityIdLocationMap[n.entityId] = n.name;
    return p ? `${p},${n.entityId}` : `${n.entityId}`
  }, '')

  useEffect(() => {
    dispatch(getDealerRefundHistory({ orgIds: entityIds, startDate, endDate, token }))
  }, [startDate, endDate, token, dispatch, entityIds])




  //--

  useEffect(() => {
    dispatch(getDealerPurchaseReport({ userEmail, startDate, endDate, token }))
  }, [startDate, endDate, userEmail, token, dispatch])

  useEffect(() => {
    const canPurchaseOn = canPurchaseEnabled && canPurchaseEnabled.length && canPurchaseEnabled.map(item => item.entityId);
    dispatch(getAuthorisationStatus({ canPurchaseOn: canPurchaseOn || [], authorised: authorised }))
  }, [canPurchaseEnabled, authorised, dispatch]);

  useEffect(() => {
    setGridDataManipulationComplete(false);
    if (dealerPurchaseHistoryData && Array.isArray(dealerPurchaseHistoryData) && dealerPurchaseHistoryData.length > 0) {
      let entityIds = dealerPurchaseHistoryData.map((item) => {
        return item.customer_org_id;
      })
      entityIds = [...new Set(entityIds)];

      dispatch(getSolutionSubscriptionInfo({ entityIds, token }))
    }
    else if (dealerPurchaseHistoryDataLoaded && dealerPurchaseHistoryData && Array.isArray(dealerPurchaseHistoryData) && dealerPurchaseHistoryData.length === 0) {
      setGridDataPrepared(true);
      setGridDataManipulationComplete(true);
    }
  }, [dealerPurchaseHistoryData, dispatch, token]);

  let updatedDealerPurchaseHistoryData = [];

  if (solutionSubscriptionInfo && Object.keys(solutionSubscriptionInfo).length > 0) {

    updatedDealerPurchaseHistoryData = JSON.parse(JSON.stringify(dealerPurchaseHistoryData));
    updatedDealerPurchaseHistoryData.forEach((item) => {

      Object.keys(solutionSubscriptionInfo).forEach((key) => {
        if (key === item.app_id) {
          item['app_details'] =
          {
            app_image: solutionSubscriptionInfo[key].overview.solutionLogo,
            app_name: solutionSubscriptionInfo[key].overview.name,
            app_id: solutionSubscriptionInfo[key].id
          }
        }
      })
    })
  }
  useEffect(() => {
    if (solutionSubscriptionInfo && Object.keys(solutionSubscriptionInfo).length > 0) {
      if (updatedDealerPurchaseHistoryData && Array.isArray(updatedDealerPurchaseHistoryData) && updatedDealerPurchaseHistoryData.length > 0 && updatedDealerPurchaseHistoryData[0].app_details) {
        setGridDataPrepared(true);
        setGridDataManipulationComplete(true);
      }
      if (dealerPurchaseHistoryDataLoaded && dealerPurchaseHistoryData && Array.isArray(dealerPurchaseHistoryData) && dealerPurchaseHistoryData.length === 0) {
        setGridDataPrepared(true);
      }
    }
  }, [solutionSubscriptionInfo])

  const tableContentRef = usePreventTableScrollingRef();
  const frameworkComponentsExtended = {
    textRenderer: TextRenderer
  };

  const onSearchInputChange = newValue => {
    setSearchInputValue(newValue);
  };

  const handleGridReady = gridParams => {
    setGridApi(gridParams.api);
    setCurrentPage(gridParams.api.paginationGetCurrentPage() + 1);
    setTotalPages(gridParams.api.paginationGetTotalPages());
    setTotalRows(gridParams.api.getDisplayedRowCount());
    gridParams.api.sizeColumnsToFit();
  };


  const handlePaginationChanged = () => {
    if (!isAgGridReady) return;
    setCurrentPage(gridApi.paginationGetCurrentPage() + 1);
    setTotalPages(gridApi.paginationGetTotalPages());
    setTotalRows(gridApi.getDisplayedRowCount());
  };

  const paginationPageSize = () => {
    if (isAgGridReady) {
      return gridApi.paginationGetPageSize();
    }

    if (defaultPaginationPageSize.value === DEFAULT_ROWS_PER_PAGE_OPTIONS[0].value) {
      return rowsPerPageOptions[0].value;
    }

    if (rowsPerPageOptions.map(rowPerPageOption => rowPerPageOption === defaultPaginationPageSize.value)) {
      return defaultPaginationPageSize.value;
    }
  };

  const handleTabbingFromPagination = event => {
    const hasRowsToDisplay = gridApi.rowModel.rowsToDisplay.length > 0;
    if (hasRowsToDisplay) {
      preventDefaultBehavior(event);
      focusLastCell(gridApi);
    }
  };

  const handleDownloadClick = () => {
    gridApi.exportDataAsCsv();
  };

  const handlePrintClick = () => {
    const isSafari = navigator.userAgent.toLowerCase().indexOf('safari/') > -1;
    gridApi.setDomLayout(TABLE_LAYOUT_OPTIONS.PRINT);
    setShowPagination(gridApi.gridOptionsWrapper.gridOptions.domLayout !== TABLE_LAYOUT_OPTIONS.PRINT);
    setTimeout(() => {
      /* In case any column width adjustments are needed - as per documentation - pinned columns
              must be unpinned and all width/height data cleared before doing it */
      if (isSafari) {
        // Safari print
        document.execCommand('print', false, null);
      } else {
        // eslint-disable-next-line no-restricted-globals
        print();
      }

      gridApi.setDomLayout(TABLE_LAYOUT_OPTIONS.AUTO_HEIGHT);
      setShowPagination(true);
    }, 500);
  };

  const handleSearchInputChange = searchInput => {
    onSearchInputChange(searchInput);

    if (gridApi) {
      gridApi.setQuickFilter(searchInput); // Refresh is needed for filtered cells highlighting to work properly

      gridApi.refreshCells({
        force: true
      });
      const displayedRowsCount = gridApi.getDisplayedRowCount();
      setTotalRows(displayedRowsCount);

      if (searchInput && displayedRowsCount === 0) {
        gridApi.showNoRowsOverlay();
      } else {
        gridApi.hideOverlay();
      }

    }
  };

  const getPageSummaryText = (currentPage, totalPages) => {
    return `Page ${currentPage} of ${totalPages}`;
  };

  const getRowsSummaryText = (currentPage, pageSize, totalRows) => {
    if (totalRows === 0) {
      return `${totalRows}-${totalRows} of ${totalRows}`;
    }

    const rowsFrom = (currentPage - 1) * pageSize + 1;
    const rowsTo = currentPage * pageSize;
    return `${rowsFrom}-${rowsTo > totalRows ? totalRows : rowsTo} of ${totalRows}`;
  };

  const paginationProps = {
    ariaLabel: 'Pagination',
    buttonLabels: {
      goToFirst: 'Go to first',
      goToLast: 'Go to last',
      goToNext: 'Go to next',
      goToPrevious: 'Go to previous'
    },
    className: '',
    dataTestId: `purchase-history-table-pagination`,
    defaultPaginationPageSize: DEFAULT_ROWS_PER_PAGE_OPTIONS[0],
    gridApi,
    hideBorder: false,
    onTabbingIntoTable: handleTabbingFromPagination,
    pageSizeDropdownId: `purchase-history-page-size-dropdown-table`,
    pageSummaryLabelId: `purchase-history-pagination-summary-label-table`,
    pageSummaryText: getPageSummaryText(totalPages === 0 ? 0 : currentPage, totalPages),
    rowsPerPageLabel: 'Rows per page:',
    rowsPerPageOptions: DEFAULT_ROWS_PER_PAGE_OPTIONS,
    rowsSummaryText: getRowsSummaryText(currentPage, paginationPageSize(), totalRows),
    showGoToFirstLastPage: true
  };
  const headerProps = {
    className: '',
    dataTestId: `purchase-history-table-header`,
    disableDownloadButton: hasNoRows,
    disablePrintButton: hasNoRows,
    downloadButtonText: 'Download button',
    hideBorder: false,
    hideTableTitle: false,
    id: `purchase-history-table-header`,
    isAlwaysExpanded: false,
    isDownloadable: true,
    isPrintable: true,
    isSearchable: true,
    onDownloadClick: handleDownloadClick,
    onPrintClick: handlePrintClick,
    onSearchInputChange: handleSearchInputChange,
    overflowButtonProps: undefined,
    printButtonText: 'Print button',
    searchInputName: 'purchase-history-search-input',
    searchInputValue: searchInputValue,
    searchPlaceholder: 'Search all columns'
  };

  const customDownloadRenderer = props => {
    // eslint-disable-next-line react/prop-types
    const {
      value
    } = props;

    return (<div className='purchase-history-download'>
      <span>
        <a href={value} target="_blank" rel="noreferrer">
          <IconFileDownload height={24} width={24} />
        </a>
      </span>
    </div>)

  };

  const customAppNameRenderer = props => {
    const { app_details = {} } = props.data;

    return (<div className="purchase-history-app-block">
      <span className="purchase-history-app-logo-container">
        <img
          src={app_details.app_image}
          alt="App Logo"
          className="purchase-history-app-logo"
        ></img>
      </span>
      <span className="purchase-history-app-name">
        <a className='purchase-history-app-link' href={environmentURLs.REACT_APP_MARKETPLACE_URL + 'solutions/' + app_details.app_id} target="_blank" rel="noreferrer">
          {app_details.app_name}
        </a>
      </span>
    </div>)

  }

  const columns = [
    {
      cellRendererFramework: customAppNameRenderer,
      field: 'app_details',
      headerName: 'App Name',
      headerTooltip: 'App Name',
      minWidth: 180,
      width: 250,
      wrapText: true
    },
    {
      cellRenderer: CELL_RENDERERS.TEXT,
      field: 'created',
      headerName: 'Purchased On',
      headerTooltip: 'Purchased On',
      minWidth: 150,
      width: 180,
      sortable: true
    },
    {
      cellClass: [CELL_CLASSES.ALIGN_CELL_RIGHT, CELL_CLASSES.NUMERIC_CELL],
      cellRenderer: CELL_RENDERERS.TEXT,
      field: 'total_charge',
      headerName: 'Purchase Amount',
      headerTooltip: 'Purchase Amount',
      minWidth: 100,
      width: 150,
      sortable: true,
      sortingOrder: ['desc', 'asc'],
      type: COLUMN_TYPES.NUMERIC_COLUMN
    },
    {
      cellRenderer: CELL_RENDERERS.TEXT,
      field: 'payment_type',
      headerName: 'Method of Payment',
      headerTooltip: 'Method of Payment',
      minWidth: 100,
      width: 150
    },
    {
      cellRenderer: CELL_RENDERERS.TEXT,
      field: 'modified_by_user_name',
      headerName: 'Purchaser',
      headerTooltip: 'Purchaser',
      minWidth: 250,
      width: 300,
      wrapText: true
    },
    {
      cellRenderer: CELL_RENDERERS.TEXT,
      field: 'customer_name',
      headerName: 'Location',
      headerTooltip: 'Location',
      minWidth: 250,
      width: 300,
      wrapText: true
    },
    {
      cellRendererFramework: customDownloadRenderer,
      field: 'receipt_url',
      headerName: 'Receipt',
      headerTooltip: 'Receipt',
      minWidth: 100,
      width: 80,
      wrapText: true
    }
  ]

  let reObj = { solutionSubscriptionInfo, dealerRefundHistoryData, dealerRefundHistoryDataLoaded, errorInGettingDealerRefundeHistroyData, entityIdLocationMap }

  return (

    <Page>
        {(gridDataPrepared && dealerPurchaseHistoryDataLoaded && gridDataManipulationComplete) ?

          <div >
            <div className='grid-container'>
              <div></div>
              <div className='purchase-history-title'>Purchase History</div>
              <div></div>
            </div>

            <div className='grid-container'>
              <div></div>
              <div className='grid-date-picker'>
                <DateRangePicker
                  allowDaysInPast={true}
                  endDate={endDate} endDateInputName="end-date-input-simple"
                  endDateLabel="End Date"
                  id="date-range-picker-purchse-history"
                  onDatesChange={handleDateChange} startDate={startDate}
                  startDateInputName="start-date-input-simple"
                  highlightToday={true} startDateLabel="Start Date"
                  isOutsideRange={isOutsideRange} />
              </div>
              <div></div>
            </div>


            <div className='grid-container'>
              <div />
              <div className='tab-component'>
                <Tabs
                  activeItemIndex={activeItemIndex}
                  items={[

                    {
                      id: 'tab-1',
                      panelId: 'panel-1',
                      renderPanel: (props) => (
                        <TabPanel {...props}>

                          <div id='purchaseHistoryConatiner'>
                            <TableContainer className={tableClass} >
                              <TableHeader {...headerProps} />
                              <TableContent data-testid="table-content" ref={tableContentRef}>
                                <AgGridReact defaultColDef={{
                                  width: 300,
                                  sortable: true
                                }}
                                  frameworkComponents={frameworkComponentsExtended}
                                  columnDefs={columns}
                                  onGridReady={handleGridReady}
                                  rowData={updatedDealerPurchaseHistoryData}
                                  onPaginationChanged={handlePaginationChanged}
                                  pagination={true}
                                  paginationPageSize={paginationPageSize()}
                                  paginationAutoPageSize={false}
                                  suppressPaginationPanel rowHeight={42} />
                              </TableContent>
                              {isAgGridReady && showPagination && <TablePagination defaultPaginationPageSize={defaultPaginationPageSize} {...paginationProps} />}
                              <TableColumnDndContainer />
                            </TableContainer>
                          </div>

                        </TabPanel>
                      ),
                      renderTab: (props) => (
                        <Tab label={`Purchase`} hideLabel={false}  {...props} />
                      )
                    },
                    {
                      id: 'tab-2',
                      panelId: 'panel-2',
                      renderPanel: (props) => (
                        <TabPanel {...props}>

                          <div id='purchaseHistoryConatiner'>
                            <RefundReport {...reObj}></RefundReport>
                          </div>

                        </TabPanel>
                      ),
                      renderTab: (props) => (
                        <Tab label={`Refund`} hideLabel={false} {...props} />
                      ),
                    }
                  ]}
                  onActiveItemChange={setActiveItemIndex}
                />
              </div>

            </div>


          </div>
          :
          (!errorInGettingDealerPurchaseHistroyData && !gridDataManipulationComplete) &&
          <Loader style={LOADER_STYLE} label="Generating Report..." />
        }
        {
          errorInGettingDealerPurchaseHistroyData &&
          <div>
            <h1>Something went wrong.</h1>
            <h2>
              Please contact Fortellis Support at support@fortellis.io
            </h2>
          </div>
        }
    </Page>
  );
};

export default withRouter(AuthComponent(PurchaseReport));
